import './App.css';
import NavBar from './components/navBar';
import Footer from './components/footer';
import Home from './pages/home';
import Project from './pages/projects';
import Contact from './pages/contact';
import changeBodyBackground from './helpers/changeBodyBackground.js'
import ScrollToTopPage from './components/scrollToTop';

import ScrollToTop from 'react-scroll-to-top'
import { useEffect } from "react"
import Aos from "aos"
import { useTranslation } from "react-i18next";

//img
import '/node_modules/flag-icons/css/flag-icons.min.css'

const App = () => {
  // eslint-disable-next-line no-unused-vars
  const [t,i18n] = useTranslation("global");
  
    useEffect(() => {
      Aos.init({duration: 1000});
    }, []);

    const addLangLS = (lg) => {
      window.localStorage.setItem("lang", lg);
    };
    
  return (
    <div className="App">
      <input type="checkbox" className="switch ios" onClick={()=> changeBodyBackground()}></input>
      <div className='flags'>
        <span className="fi fi-es" onClick={()=> {i18n.changeLanguage("es"); addLangLS("es")}}></span> 
        <span className="fi fi-gb" onClick={()=> {i18n.changeLanguage("en"); addLangLS("en")}}></span>
      </div>

      <ScrollToTop/>
      <ScrollToTopPage />

      <NavBar/>

      <Home/>
      <Project/>
      <Contact/>

      <Footer/>
    </div>
  );
}

export default App;
